import React, { Component } from "react";

import { firebaseConnect } from "react-redux-firebase";
class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = { email: "", password: "" };
  }

  componentWillMount() {}

  componentWillUnmount() {}

  handleChangeEmail(event) {
    this.setState({ email: event.target.value });
  }

  handleChangePassword(event) {
    this.setState({ password: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.firebase.login({
      email: this.state.email,
      password: this.state.password
    });
    return false;
  }

  render() {
    return (
      <form className="LoginForm" onSubmit={this.handleSubmit.bind(this)}>
        <input
          placeholder="Email"
          type="email"
          value={this.state.email}
          onChange={this.handleChangeEmail.bind(this)}
        />
        <input
          placeholder="Password"
          type="password"
          value={this.state.password}
          onChange={this.handleChangePassword.bind(this)}
        />
        <input className="clickable" type="submit" />
      </form>
    );
  }
}

export default firebaseConnect()(LoginForm);



// WEBPACK FOOTER //
// ./src/routes/login/loginForm.js